module.exports = __webpack_public_path__ + "static/media/img_Inscription_none@2x.51069627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_Inscription_none@2x.png
// module id = 998
// module chunks = 0